import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Media from "react-media";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import PlanSelector from "../../components/PlanSelector";
import PromoCodeContainer from "../../components/becomePro/PromoCodeContainer";
import { Layout } from "../../contexts/LayoutContext";
import PromoCodeContext from "../../contexts/PromoCodeContext";
import { QueryStringContext } from "../../contexts/QueryStringContext";
import GlobalTheme from "../../styled/GlobalTheme";
import { container } from "../../styled/mixins";
import roles from "../../utils/constants/roles";
import { QUERY_KEYS, QUERY_VALUES } from "../../utils/constants/settings";
import mediaQueries from "../../utils/mediaQueries";
import AppleButton from "../auth/components/AppleButton";
import FacebookButton from "../auth/components/FacebookButton";
import CreateAccountForm from "./Form";
import PiperPresentation from "./components/PiperPresentation";
import BillingPeriodSwitcher from "../../components/BillingPeriodSwitcher";
import PlanProvider from "../../components/PlanSelector/index.provider";

// TODO: Quitar esto luego
function parseJwt (token) {
  try {
      // Obtenemos solo la parte del payload del token
      const base64Url = token.split('.')[1];
      // Reemplazamos los caracteres no permitidos en base64 y decodificamos
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
  } catch (e) {
      return null;
  }
};

export default () => {
  const intl = useIntl();
  const location = useLocation();
  const history = useHistory();
  const { PromoCode, promoLock, handlePromoCodeChange } =
    useContext(PromoCodeContext);
  const { getQueryStringVal } = useContext(QueryStringContext);
  const [planSelected, setPlanSelected] = useState("P");
  const typeOfTrial = getQueryStringVal(QUERY_KEYS.tt);
  const isOptIn = typeOfTrial === QUERY_VALUES.tt;

  const query1 = new URLSearchParams(location.search);
  const partnerToken = query1.get('partnerToken')
  const decoded = partnerToken ? parseJwt(partnerToken) : null;

  useEffect(() => {
    setPlanSelected((location.state && location.state.plan) || "P");
  }, []);

  return (
    <Media queries={mediaQueries}>
      {(matches) => (
        <Layout
          title={intl.formatMessage({
            id: "onboarding.createAccount.title",
            defaultMessage: "Create your account",
          })}
          description={intl.formatMessage({
            id: "onboarding.createAccount.description",
            defaultMessage: "Start your 30-day free trial.",
          })}
          accessOnTrialEnds
        >
          <Container>
            <MainGrid>
              {matches.xlUp && <PiperPresentation position="top" marginTop />}
              {(matches.lg || matches.md || matches.sm) && (
                <PiperPresentation />
              )}
              <ContentSection>
                {!decoded && <SectionHeaderWrapperComponent
                  number={1}
                  intlid="onboarding.createAccount.selectPlan.title"
                >
                  <BillingPeriodSwitcher />
                </SectionHeaderWrapperComponent>}
                {!decoded && <PlanSelector planSelected={planSelected} />}
                {!decoded && <PromoContainerHide isFullmgt={PromoCode.code === "FULL_MNGT"}>
                  <PromoCodeContainer
                    promoCode={PromoCode}
                    isLoading={promoLock}
                    onChangeHandler={handlePromoCodeChange}
                    trialEnabled
                  />
                </PromoContainerHide>}
                <SectionHeaderWrapperComponent
                  intlid="onboarding.creteAccount.heading"
                  opacity={planSelected ? "1" : "0.25"}
                  margin="32px 0 32px"
                  number={2}
                ></SectionHeaderWrapperComponent>
                {/** erase #1 */}
                <CreateAccountForm
                  wantsFree={roles.PRO}
                  planSelected={planSelected}
                  collaboratorData={decoded}
                />

                {!decoded && <SectionTitle bold marginTop>
                  <TextSignupWith>
                    <FormattedMessage
                      id="signup.createAccount.option.text"
                      defaultMessage="Or sign up with:"
                    />
                  </TextSignupWith>
                </SectionTitle>}

                {!decoded && <ButtonContainerSN>
                  <FacebookButton
                    PromoCode={PromoCode}
                    wantsFree={false}
                    disabled={!planSelected}
                    buttonType="signupapp"
                  />
                  <Spacing />
                  <AppleButton
                    PromoCode={PromoCode}
                    wantsFree={false}
                    buttonType="signup"
                  />
                </ButtonContainerSN>}
              </ContentSection>
            </MainGrid>
            <LegalAccept>
              <FormattedMessage
                id="onboarding.creteAccount.acceptAllTerms"
                defaultMessage="By registering, you are accepting: <terms>Terms of Service</terms>, <cookies>Cookies Policy</cookies>, <privacy>Privacy Policy</privacy>, <caPrivacy>CA Privacy Rights</caPrivacy> and <doNotSell>Do Not Sell My Information</doNotSell> of Social Piper, and you will be automatically registered to receive emails about new Social Piper products, best practices or special offers, until you opt out."
                values={{
                  terms: (...chunks) => (
                    <LegalLink
                      target="_blank"
                      href="https://legal.socialpiper.com/social-piper-terms-of-service-2020-07-31/"
                    >
                      {chunks}
                    </LegalLink>
                  ),
                  cookies: (...chunks) => (
                    <LegalLink
                      target="_blank"
                      href="https://legal.socialpiper.com/social-piper-cookie-policy-2020-08-03/"
                    >
                      {chunks}
                    </LegalLink>
                  ),
                  privacy: (...chunks) => (
                    <LegalLink
                      target="_blank"
                      href="https://legal.socialpiper.com/social-piper-privacy-policy-2020-08-03/"
                    >
                      {chunks}
                    </LegalLink>
                  ),
                  caPrivacy: (...chunks) => (
                    <LegalLink
                      target="_blank"
                      href="https://legal.socialpiper.com/social-piper-ca-privacy-policy-2020-08-03/"
                    >
                      {chunks}
                    </LegalLink>
                  ),
                  doNotSell: (...chunks) => (
                    <LegalLink
                      target="_blank"
                      href="https://legal.socialpiper.com/social-piper-do-not-sell-my-personal-information-2020-08-03/"
                    >
                      {chunks}
                    </LegalLink>
                  ),
                }}
              />
            </LegalAccept>
          </Container>
        </Layout>
      )}
    </Media>
  );
};

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 740px;
  ${GlobalTheme.breakpoints.down("lg")} {
    margin: 0 auto;
  }
`;

const LegalAccept = styled.div`
  margin: 80px 12% 30px 12%;
  font-size: 16px;
  color: ${(props) => props.theme.colors.text02};
  text-align: center;
`;

const LegalLink = styled.a`
  color: ${(props) => props.theme.colors.lightBlue};
  text-decoration: underline;
`;

const Container = styled.div`
  ${container};
  padding-top: 30px;
  padding-bottom: 16px;
`;

const MainGrid = styled.div`
  display: grid;
  grid-gap: ${(props) => props.theme.space * 4}px;
  grid-template-columns: 245px 1fr;
  ${GlobalTheme.breakpoints.down("lg")} {
    grid-template-columns: 1fr;
  }
`;

const HeaderSphere = styled.span`
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 100%;
  font-size: 30px;
  font-weight: 400;
  background: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.black};
`;

const SectionHeaderWrapperComponent = (props) => {
  return (
    <SectionHeader {...props}>
      <SectionHeaderWrapper>
        {props.number && <HeaderSphere>{props.number}</HeaderSphere>}
        {props.intlid && (
          <SectionHeaderText>
            <FormattedMessage id={props.intlid} description="-" />
          </SectionHeaderText>
        )}
      </SectionHeaderWrapper>
      {props.children}
    </SectionHeader>
  );
};

const SectionHeaderText = styled.p`
  font-size: 36px;
  font-weight: 600;
  margin: 0;
`;

const SectionHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 32px 0 16px 0;
  margin: ${(props) => props.margin || "0 0 32px"};
  opacity: ${(props) => props.opacity || "1"};
  ${GlobalTheme.breakpoints.down("lg")} {
    margin: 0 0 16px 0;
  }
  ${GlobalTheme.breakpoints.down("sm")} {
    margin: 16px 0;
  }
`;

const SectionTitle = styled.div`
  text-align: left;
  width: 100%;

  ${(props) =>
    props.space &&
    `
    padding-bottom: 30px;
    border-bottom: 1px solid #909090;
  `}
  ${(props) =>
    props.bold &&
    `
    font-weight: 600;
  `}

  ${(props) =>
    props.marginTop &&
    `
    margin-top: 30px;
  `}
  &:nth-child(3) {
    ${({ promocode }) =>
      !promocode &&
      `
      font-size: 14px;
      font-style: italic;
      font-weight: 300;
      @media ${mediaQueries.mdUp} {
        font-size: 16px;
      }
    `}
  }
`;

const SectionRequiredText = styled.div`
  text-align: left;
  width: 100%;
  font-size: 12px;
  padding: 15px 0;
  color: ${(props) => props.theme.colors.orange};
`;

const ButtonContainerSN = styled.div`
  text-align: center;
  padding: 0 15%;
  width: 100%;
  display: flex;
  flex-direction: row;
  ${GlobalTheme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`;

const Spacing = styled.div`
  width: 10%;
  ${GlobalTheme.breakpoints.down("sm")} {
    height: 25px;
  }
`;

const TextSignupWith = styled.div`
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  ${GlobalTheme.breakpoints.down("sm")} {
    padding-top: 50px;
  }
`;

const TextTrial = styled.span`
  color: ${(props) => props.theme.colors.primaryMoreLighter};
`;

const BlueText = styled.span`
  color: ${(props) => props.theme.colors.lightBlue};
  font-weight: 700;
`;
const LinkText = styled.span`
  color: ${({ theme }) => theme.colors.lightBlue};
  cursor: pointer;
  font-style: normal;
`;

const PromoContainerHide = styled.div``;
